import React, { useContext, useEffect, useRef, useState } from 'react';

import { DayPicker } from 'react-day-picker';
import '../../../../../stylesheets/tools/_react-daypicker.css';

import { lightFormat as formatDate, addYears } from 'date-fns';

import { CalendarContext } from '../../context/CalendarContext.jsx';
import SvgDefaultCalendar from '../../../../svg/icons/default-calendar.svg';

function NextIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" id="default-arrow-right">
      <path fill="currentColor" d="M9.155 16.975L13.44 11.2 9.155 5.5H6.56l4.359 5.738-4.247 5.737z" />
    </svg>
  );
}

function PrevIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" id="default-arrow-left">
      <path fill="currentColor" d="M10.845 16.975L6.56 11.2l4.285-5.7h2.595l-4.359 5.738 4.247 5.737z" />
    </svg>
  );
}

function FilterDate() {
  const { config, locale, filter, updateFilter } = useContext(CalendarContext);
  const { from, to } = filter.date || { from: undefined, to: undefined };

  const [showDayPicker, setShowDayPicker] = useState(false);

  const defaultSelected = {
    from,
    to
  };

  const [range, setRange] = useState(defaultSelected);

  useEffect(() => {
    updateFilter((prev) => ({ ...prev, date: range }));
  }, [range]);

  useEffect(() => {
    if (filter.date.to === range.to && filter.date.from === range.from) return;
    setRange(defaultSelected);
  }, [filter.date]);

  const commonDayPickerProps = {
    mode: 'range',
    locale,
    fixedWeeks: true,
    showOutsideDays: true,
    enableOutsideDaysClick: true,
    fromYear: 1990,
    toYear: formatDate(addYears(new Date(), 1), 'yyyy'),
    today: new Date(),
    labels: {
      labelNext: () => config.labels.nextMonth,
      labelPrevious: () => config.labels.previousMonth
    },
    components: {
      IconNext: NextIcon,
      IconPrevious: PrevIcon
    }
  };

  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) setShowDayPicker(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return (
    <div className="filter-date">
      <div className="filter-date__input-wrapper">
        <div className="filter-date__input filter-date__input--from">
          <form>
            <input
              value={range?.from ? formatDate(range.from, config.date.format) : ''}
              onFocus={() => setShowDayPicker(true)}
              placeholder={config.date.format.toUpperCase()}
              readOnly
            />
          </form>
          <SvgDefaultCalendar className="filter-date__icon" />
        </div>
        <div className="filter-date__input filter-date__input--to">
          <form>
            <input
              value={range?.to ? formatDate(range.to, config.date.format) : ''}
              onFocus={() => setShowDayPicker(true)}
              placeholder={config.date.format.toUpperCase()}
              readOnly
            />
          </form>
          <SvgDefaultCalendar className="filter-date__icon" />
        </div>
      </div>

      {showDayPicker && (
        <div ref={ref} className="filter-date__day-picker">
          <DayPicker selected={range} onSelect={setRange} {...commonDayPickerProps} />
        </div>
      )}
    </div>
  );
}

export default FilterDate;
